import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { AlertTriangle, CreditCard } from 'lucide-react';

// Inline error card shown when a credit-consuming action (AI transcription,
// AI assessment, manual audit) is blocked because the company balance is 0.
const CreditBlockCard = ({ balance = 0, required, action = 'This action', onDismiss }) => {
  const navigate = useNavigate();

  return (
    <div
      className="flex items-start gap-3 p-4 rounded-xl border border-rose-200 bg-rose-50"
      data-testid="credit-block-card"
    >
      <AlertTriangle size={20} className="text-rose-600 shrink-0 mt-0.5" />
      <div className="flex-1">
        <p className="font-semibold text-rose-800">Out of credits</p>
        <p className="text-sm text-rose-700 mt-0.5">
          Your company has {balance} credit{balance === 1 ? '' : 's'} left
          {required ? `, but ${action} needs ${required}.` : `. ${action} is blocked.`} Top up to
          continue.
        </p>
        <div className="flex gap-2 mt-3">
          <Button
            size="sm"
            onClick={() => navigate('/credits')}
            className="bg-rose-600 hover:bg-rose-700 text-white"
            data-testid="credit-block-topup-btn"
          >
            <CreditCard size={14} className="mr-1.5" />
            Top Up Credits
          </Button>
          {onDismiss && (
            <Button
              size="sm"
              variant="ghost"
              onClick={onDismiss}
              className="text-rose-600 hover:bg-rose-100"
              data-testid="credit-block-dismiss-btn"
            >
              Dismiss
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreditBlockCard;
